import { BaseContainer } from "components/containers";
import { FillButton,  } from 'components/elements';
import { Flex, Descriptions, } from "antd";
import { getAmountWithComma } from 'utils/utils';

export const SearchDesc = ({stats=null, items, column, inline, labelStyle=null, onSearch}) => {

    return (
        <BaseContainer>
            <div className="search-box">
                <div className="stats-wrap">
                    {
                        (stats && stats.length > 0) && stats.map((item, idx) => (
                            <span key={idx}>
                                {
                                    idx === 0 ? <>{item.STATISTICS_NAME} : {getAmountWithComma(item.STATISTICS_COLUM_VALUE)} {item.UNIT}</> 
                                    : 
                                    <>, {item.STATISTICS_NAME} : {getAmountWithComma(item.STATISTICS_COLUM_VALUE)} {item.UNIT}</>
                                }
                            </span>
                        ))
                    }
                </div>
                {inline ? <Flex gap='small' align="middle">
                    <Descriptions 
                        bordered 
                        size='small' 
                        labelStyle={{...labelStyle}}
                        contentStyle={{ padding: '0px 20px 0px 10px' }}
                        items={items}
                        column={column}
                    />
                    </Flex> :
                    <Descriptions 
                        bordered 
                        size='small' 
                        labelStyle={{width:'7%', ...labelStyle}}
                        contentStyle={{ width: '43%' }}
                        items={items}
                        column={column}
                    />
                }
                {!inline && <Flex justify="center" style={{marginTop:'7px'}}>
                    <FillButton label='검색하기' width='100px' backgroundColor='var(--color-gray03)' onClick={onSearch}/>
                </Flex>}
            </div>
        </BaseContainer>
    )
}
